var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_12652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 2.66699H42.6668V10.667C42.6668 12.1397 41.4729 13.3336 40.0001 13.3336H24C22.5273 13.3336 21.3334 12.1397 21.3334 10.667V2.66699H10.6666C9.19388 2.66699 8 3.86099 8 5.33374V61.3337C8 62.8065 9.19388 64.0004 10.6666 64.0004H40V53.3337C40 50.3882 42.3879 48.0004 45.3334 48.0004H56V5.33374C56 3.86099 54.8061 2.66699 53.3334 2.66699ZM16 37.3337H26.6666V42.6671H16V37.3337ZM34.6666 53.3337H16V48.0004H34.6666V53.3337ZM40 26.667C37.8951 29.8419 35.1749 32.5621 32 34.667C28.8251 32.5621 26.1049 29.8419 24 26.667C21.3334 21.3336 26.6666 16.0004 32 21.3336C37.3334 16.0004 42.6666 21.3337 40 26.667Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.667 53.3337V64.0004L56.0004 50.667H45.3337C43.861 50.667 42.667 51.861 42.667 53.3337Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3336 0H26.667V2.66662H37.3336V0Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 10.6663C33.4724 10.6663 34.6663 9.47237 34.6663 7.99963C34.6663 6.5269 33.4724 5.33301 31.9996 5.33301C30.5269 5.33301 29.333 6.5269 29.333 7.99963C29.333 9.47237 30.5269 10.6663 31.9996 10.6663Z",
    fill: "#B8B8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_12652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthCertificate);
export default __webpack_public_path__ + "static/media/birth-certificate.82e4b03bd587d61a9a50e0a5ed92837f.svg";
export { ForwardRef as ReactComponent };